module.exports = __webpack_public_path__ + "assets/img/avatar.75d19238.png";